import {DIVAY_URL, DATE_TIME_FORMAT, LOGIN_STATUS, SESSION_TIMEOUT} from '../../../configs/app-configs'
import {
  CHANGE_SESSION_EXPIRE_TIME,
  LOGIN_ACTION,
  LOGIN_FAIL_ACTION,
  LOGOUT_ACTION,
  SAVE_REGISTER_TOKEN,
  SAVE_RESET_PASSWORD_TOKEN,
  UPDATE_USER_INFO,
} from '../../actions/auth'
import moment from "moment";

const authInitialState = {
  authToken: '',
  user: '',
  loginStatus: '',
  register: { user: {}, token: '' },
  resetPasswordToken: '',
  errorMessage : '',
  divayUserInfo : {},
  sessionExpireTime : null,
}


export const authReducers = (state = { ...authInitialState }, action) => {
  switch (action.type) {
    case LOGIN_ACTION: {
      return { ...state, ...action.payload, loginStatus: LOGIN_STATUS.SUCCESS, errorMessage: '' }
    }
    case LOGOUT_ACTION: {
      return { ...authInitialState }
    }
    case LOGIN_FAIL_ACTION: {
      return { ...state, loginStatus: LOGIN_STATUS.FAIL, errorMessage: action.payload }
    }
    case SAVE_REGISTER_TOKEN: {
      return { ...state, register: action.payload }
    }
    case SAVE_RESET_PASSWORD_TOKEN: {
      return { ...state, resetPasswordToken: action.payload }
    }
    case UPDATE_USER_INFO: {
      return { ...state, user: action.payload }
    }
    case CHANGE_SESSION_EXPIRE_TIME : {
      return {...state, sessionExpireTime: moment().add(SESSION_TIMEOUT, 'minutes').format(DATE_TIME_FORMAT)}
    }
    default:
      return state
  }
}

export default authReducers
